import React from 'react';
import { Building2, Zap, Network } from 'lucide-react';

const BROKERS = [
  { name: 'Alpaca', tag: 'Equities · Options', mode: 'OAuth' },
  { name: 'Tradovate', tag: 'Futures', mode: 'API Token' },
  { name: 'Interactive Brokers', tag: 'Global Multi-Asset', mode: 'OAuth' },
  { name: 'TradeStation', tag: 'Coming Soon', mode: 'Q3 2026', soon: true },
];

export default function Brokers() {
  return (
    <section className="relative border-t border-[rgba(201,162,75,0.10)]">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-5 sm:px-6 lg:px-12 py-12 lg:py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-14">
          <div className="lg:col-span-2">
            <p className="text-[10px] tracking-[0.25em] font-mono gold-text">BROKER INTEGRATIONS</p>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl md:text-5xl font-bold leading-[1.05] text-white">
              Connect once.
              <br />
              <span className="gold-text">Trade everywhere.</span>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-sm text-[#CDBE94] leading-relaxed">
              Direct broker integrations via OAuth or encrypted API tokens. Full credentials are never displayed back to users or operators.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {BROKERS.map((b) => (
            <div
              key={b.name}
              className={`relative border rounded-md p-6 bg-[#0c0c0e] ${
                b.soon ? 'border-white/[0.05]' : 'border-[rgba(201,162,75,0.16)] hover:border-[#d8b34a]/40 transition-colors'
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="w-10 h-10 border gold-border rounded-sm flex items-center justify-center">
                  <Building2 size={16} className="gold-text" strokeWidth={1.6} />
                </div>
                <span className={`text-[10px] font-mono tracking-wider ${b.soon ? 'text-[#A99563]' : 'gold-text'}`}>
                  {b.mode}
                </span>
              </div>
              <h3 className={`mt-6 text-lg font-semibold ${b.soon ? 'text-[#A99563]' : 'text-white'}`}>
                {b.name}
              </h3>
              <p className="mt-1.5 text-xs text-[#A99563]">{b.tag}</p>
              <div className="mt-6 pt-5 border-t border-[rgba(201,162,75,0.10)] flex items-center gap-2">
                <span className={`w-1.5 h-1.5 rounded-full ${b.soon ? 'bg-zinc-700' : 'bg-emerald-400 dot-pulse'}`} />
                <span className="text-[10px] font-mono tracking-widest text-[#A99563]">
                  {b.soon ? 'PLANNED' : 'SUPPORTED'}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="border border-white/[0.08] rounded-md p-6 bg-[#0c0c0e]">
            <Zap size={16} className="gold-text" strokeWidth={1.6} />
            <h4 className="mt-4 text-sm font-semibold text-white">Encrypted at rest</h4>
            <p className="mt-2 text-xs text-[#CDBE94] leading-relaxed">
              Broker tokens stored with Fernet symmetric encryption and rotating keys.
            </p>
          </div>
          <div className="border border-white/[0.08] rounded-md p-6 bg-[#0c0c0e]">
            <Network size={16} className="gold-text" strokeWidth={1.6} />
            <h4 className="mt-4 text-sm font-semibold text-white">Sub-second heartbeat</h4>
            <p className="mt-2 text-xs text-[#CDBE94] leading-relaxed">
              Continuous broker connectivity monitoring with instant disconnect alerts.
            </p>
          </div>
          <div className="border border-white/[0.08] rounded-md p-6 bg-[#0c0c0e]">
            <Building2 size={16} className="gold-text" strokeWidth={1.6} />
            <h4 className="mt-4 text-sm font-semibold text-white">Revoke anytime</h4>
            <p className="mt-2 text-xs text-[#CDBE94] leading-relaxed">
              Disconnect a broker from your dashboard in one click. Tokens immediately invalidated.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
